// extracted by mini-css-extract-plugin
export default {"backButton":"PanelHeader_backButton__jI2sY"};